import { useEffect, useState } from 'react';

// Re-renders once, when the moment passes, so a page left open catches up with
// the clock. A check every minute rather than a timeout set for the moment: a
// timeout further off than about 24 days fires at once.
export const useHasPassed = (moment: Date) => {
  const time = moment.getTime();
  const [, setPassedAt] = useState(0);

  useEffect(() => {
    if (Date.now() > time) return;
    const interval = setInterval(() => {
      const now = Date.now();
      if (now <= time) return;
      clearInterval(interval);
      setPassedAt(now);
    }, 60_000);
    return () => clearInterval(interval);
  }, [time]);

  return Date.now() > time;
};
